import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';
export const FollowBrandButton = styled.div`
  background-color: transparent;
  color: ${props => props.color};
  border-color: ${props => props.color};

  ${props => props.isLoading && `
    pointer-events: none;
    opacity: 0.4;

    > button > * {
      visibility: hidden;
    }
  `}

  &:hover {
    color: ${({
  theme
}) => theme.base.black};
    background: ${({
  theme
}) => theme.base.white};
  }

  &:active {
    color: ${({
  theme
}) => theme.secondary.dark};
    border-color: ${({
  theme
}) => theme.secondary.dark};
  }

  &:disabled {
    cursor: default;
  }
`;
export const TextFollow = styled.span`
  margin-right: 2px;

  ${breakpoints.md} {
    margin-left: 2px;
  }
`;